var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "email-confirmation" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "b-container",
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                {
                  attrs: {
                    xl: "8",
                    "offset-xl": "2",
                    "offset-md": "1",
                    md: "10",
                    sm: "12"
                  }
                },
                [
                  _vm.isValid && !_vm.isPhoneVerifed
                    ? _c("div", { staticClass: "form-container" }, [
                        _c("div", { staticClass: "form__title" }, [
                          _c(
                            "div",
                            [
                              _c("h3", [
                                _vm._v(
                                  _vm._s(_vm.$t("Welcome to")) + " Kweeder"
                                )
                              ]),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "To complete your registration, please insert below the sms 6 digits token sent to mobile nº"
                                    )
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "token-container" },
                                [
                                  _c("kw-token", {
                                    attrs: { id: "phonetoken" },
                                    model: {
                                      value: _vm.phoneToken,
                                      callback: function($$v) {
                                        _vm.phoneToken = $$v
                                      },
                                      expression: "phoneToken"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("kw-button", {
                                    attrs: {
                                      label: _vm.$t("New token"),
                                      type: "submit",
                                      isPrimary: false,
                                      isLoading: _vm.isWaitingForNewToken
                                    },
                                    on: {
                                      "update:isLoading": function($event) {
                                        _vm.isWaitingForNewToken = $event
                                      },
                                      "update:is-loading": function($event) {
                                        _vm.isWaitingForNewToken = $event
                                      }
                                    },
                                    nativeOn: {
                                      click: function($event) {
                                        return _vm.emitNewToken($event)
                                      }
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("kw-button", {
                                attrs: {
                                  label: _vm.$t("Confirm"),
                                  type: "submit",
                                  isPrimary: true,
                                  isLoading: _vm.isWaitingTokenVerification
                                },
                                on: {
                                  "update:isLoading": function($event) {
                                    _vm.isWaitingTokenVerification = $event
                                  },
                                  "update:is-loading": function($event) {
                                    _vm.isWaitingTokenVerification = $event
                                  }
                                },
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.verifySMSToken($event)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isValid && _vm.isActive
                    ? _c(
                        "kw-error",
                        {
                          attrs: {
                            title: _vm.$t("Your account is already active!"),
                            message: _vm.$t(
                              "Your account is already active! Please login"
                            )
                          }
                        },
                        [
                          _c("kw-button", {
                            attrs: { label: _vm.$t("Login") },
                            nativeOn: {
                              click: function($event) {
                                return _vm.redirect($event)
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isValid
                    ? _c(
                        "kw-error",
                        {
                          attrs: {
                            title: _vm.$t("Your token is not valid"),
                            message: _vm.$t("Your token is not valid")
                          }
                        },
                        [
                          _c(
                            "div",
                            [
                              _c("kw-email", {
                                attrs: {
                                  label: _vm.$t("email"),
                                  isUnique: false,
                                  value: _vm.email
                                },
                                on: {
                                  dataChanged: function($event) {
                                    _vm.form.email = $event
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("kw-button", {
                                attrs: {
                                  label: _vm.$t("Send email"),
                                  isPrimary: true,
                                  type: "submit",
                                  isLoading: _vm.isLoading,
                                  disabled: _vm.isFormValid
                                },
                                on: {
                                  submit: function($event) {
                                    $event.preventDefault()
                                    return _vm.onSubmit($event)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("header", { staticClass: "headerAccountCreated" }, [
      _c("div", { staticClass: "header-right" }, [
        _c("a", { attrs: { href: "/" } }, [
          _c("img", {
            staticClass: "imageLogoHeader",
            attrs: { src: require("../../../../assets/logo4login.png") }
          })
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3493c5da", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3493c5da","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/components/views/EmailConfirmation/emailConfirmation.html
// module id = null
// module chunks = 